/*
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-08 17:39:40
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-21 15:00:39
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import ArticleList from '../views/article/list.vue'
import Detail from '../views/article/detail.vue'
import Mine from '../views/mine/index.vue'
import Fans from '../views/mine/fans.vue'
import MyArticle from '../views/mine/articleAndQa.vue'
import Release from '../views/release/index.vue'
import Circle from '../views/release/circle.vue'
import Sign from '../views/sign/index.vue'
import YearReport from '../views/yearReport/index.vue';
import MyColumn from '../views/mine/columnList.vue';
import ColumnDetail from '../views/column/detail.vue';
import CircleDetail from '../views/circle/detail.vue';
import TopicDetail from "../views/topic/index.vue";
import ReadRank from '../views/read-rank/index.vue';
import PdfPreview from '../views/pdf/index.vue';
import WithOutAuth from '../views/403/index.vue';
import ProgrammerDay from '../views/programmer-day/index.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: {
      name: "articleList"
    }
  },
  {
    path: "/withOutAuth",
    name: "403",
    component: WithOutAuth
  },
  {
    path: "/articleList",
    name: "articleList",
    component: ArticleList,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/article/:id",
    name: "articleDetail",
    component: Detail
  },
  {
    path: "/articleDetail",
    name: "oldArticleDetail",
    component: Detail
  },
  {
    path: "/bbs/:id",
    name: "bbsDetail",
    component: Detail
  },
  {
    path: "/codeShow/:id",
    name: "codeShowDetail",
    component: Detail
  },
  {
    path: "/mine",
    name: "mine",
    component: Mine
  },
  {
    path: "/fans",
    name: "fans",
    component: Fans
  },
  {
    path: "/myArticle",
    name: "myArticle",
    component: MyArticle
  },
  {
    path: "/release",
    name: "release",
    component: Release
  },
  {
    path: "/circle",
    name: "circle",
    component: Circle
  },
  {
    path: "/sign",
    name: "sign",
    component: Sign
  },
  {
    path: "/yearReport",
    name: "yearReport",
    component: YearReport
  },
  {
    path: "/personal",
    name: "personal",
    component: Mine
  },
  {
    path: "/myColumns",
    name: "myColumns",
    component: MyColumn
  },
  {
    path: "/column/:id",
    name: "columnDetail",
    component: ColumnDetail,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/topic",
    name: "topicDetail",
    component: TopicDetail,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/circle/:id",
    name: "circleDetail",
    component: CircleDetail,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/read-rank",
    name: "readRank",
    component: ReadRank
  },
  {
    path: "/pdf-preview/:id",
    name: "pdfPreview",
    component: PdfPreview
  },
  {
    path: "/programmer-day",
    name: "ProgrammerDay",
    component: ProgrammerDay
  },
  {
    path: "*",
    redirect: {
      name: "articleList"
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '神灯'
  }
  next()
})

export default router